import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTag({ open, onClose, setOpen }: ModalProps) {
  

    return (
        <Modal className="modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Tag</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Fee Code */}
                            <div className="control_group">
                                <label htmlFor="tag-name">Tag Name</label>
                                <TextField
                                    placeholder="Enter Tag Name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "tag-name" }}
                                />
                            </div>

                           
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                             <img src="/static/images/ai_icon.svg" alt="icon" />   Generate With AI
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Add Tag
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
